import Tab from '../Tab';
const TabTable =({list, children, selected='',change=()=>{}, label})=>{
    return <>
        <Tab list={list} selected={selected} change={change} label={label}></Tab>
        {children}
    </>
}
export default TabTable